import { jsx } from "panel";
import { SelectAllMechanism } from "common/components/items-menu/types";
import { QueryBlockEl } from "common/query-builder/query-block";
import { MenuItemType } from "common/query-builder/query-block/properties-menu/types";
export function template() {
  const { selected } = this.state;
  const isDataGroup = !!this.attr(`data-group-id`);
  return /* @__PURE__ */ jsx(QueryBlockEl, {
    attrs: {
      type: `properties`,
      "allow-behavioral-property-creation": this.attr(`allow-behavioral-property-creation`) || true,
      "min-selection": this.attr(`allow-zero-selections`) ? 0 : 1,
      "search-placeholder": `Search profile properties`,
      "project-id": this.attr(`project-id`),
      selected,
      label: `Edit Columns \u2022 ${this.attr(`selected-properties`).length}`,
      "selector-icon": `edit`,
      "selector-type": `button`,
      "hide-events": true,
      multiple: true,
      "include-custom-properties": `all`,
      "input-only": true,
      "workspace-id": this.attr(`workspace-id`),
      "all-data-groups": isDataGroup,
      "data-group-id": this.attr(`data-group-id`),
      "project-has-people": !isDataGroup,
      "hide-recently-viewed": true,
      "hide-edit-controls": this.attr(`hide-edit-controls`),
      "exclude-dimension-properties": true,
      "show-select-all": true,
      "select-all-mechanism": SelectAllMechanism.Partial,
      "track-name": `users`,
      "selectable-sensitive-properties": true,
      theme: this.attr(`theme`),
      "menu-item-types": [MenuItemType.UserProperties]
    },
    on: {
      select: this.helpers.handleQueryBlockSelect,
      close: this.helpers.handleQueryBlockClose
    },
    props: {
      getSortedMenuSections: this.helpers.getSortedMenuSections
    }
  });
}
